import { Container } from 'src/components/common/Container'
import { PreviewPageProps } from 'src/pages/PreviewPage'
import styled from 'styled-components'
import PreviewHeader from 'src/pages/PreviewPage/_components/PreviewHeader'
import PreviewHotDeal from 'src/pages/PreviewPage/_components/PreviewHotDeal'
import PreviewAlwaysDiscount from 'src/pages/PreviewPage/_components/PreviewAlwaysDiscount'
import PreviewBottomSheet from 'src/pages/PreviewPage/_components/PreviewBottomSheet'
import { layoutMaxSize } from 'src/styles/mixin'

const PreviewPageView = (props: PreviewPageProps) => {
  return (
    <S.PreviewPageContainer>
      <PreviewHeader />
      <S.ContentContainer $option="flex_column" $row_gap="20px">
        <PreviewHotDeal {...props} />
        <PreviewAlwaysDiscount {...props} />
      </S.ContentContainer>
      <PreviewBottomSheet {...props} />
    </S.PreviewPageContainer>
  )
}

export default PreviewPageView

const S = {
  PreviewPageContainer: styled(Container)`
    ${layoutMaxSize};
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    min-width: 320px;
  `,
  ContentContainer: styled(Container)`
    padding: 0 0 50px;
  `,
}
